import { useCallback, useEffect, useRef, useState } from 'react'

/**
 * Tô sáng tạm thời một tập id.
 *
 * Dùng cho bảng máy trạm: hàng vừa có biến động sáng lên vài giây rồi trở lại
 * bình thường, để người ở kho biết dòng nào là dòng vừa đổi. Không có nó thì
 * màn nhảy sang nhưng không ai biết vì sao.
 */
export function useTemporaryHighlight(durationMs: number) {
    const [ids, setIds] = useState<ReadonlySet<string>>(() => new Set())
    const timers = useRef<Map<string, ReturnType<typeof setTimeout>>>(new Map())

    useEffect(() => {
        const running = timers.current
        return () => {
            for (const timer of running.values()) clearTimeout(timer)
            running.clear()
        }
    }, [])

    const mark = useCallback(
        (id: string | undefined) => {
            if (!id) return
            setIds((prev) => new Set(prev).add(id))
            // Biến động thứ hai trên cùng một hàng phải gia hạn vệt sáng; giữ
            // hẹn giờ cũ thì nó vẫn nổ và tắt sáng sớm.
            const running = timers.current.get(id)
            if (running) clearTimeout(running)
            timers.current.set(
                id,
                setTimeout(() => {
                    setIds((prev) => {
                        const next = new Set(prev)
                        next.delete(id)
                        return next
                    })
                    timers.current.delete(id)
                }, durationMs),
            )
        },
        [durationMs],
    )

    return { ids, mark }
}
